var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91474 0.500977L11.7312 2.31745L9.44878 4.58409L10.5703 5.70556L12.8369 3.42313L14.6534 5.2396V0.500977H9.91474ZM0.4375 5.2396L2.25397 3.42313L4.52061 5.70556L5.64209 4.58409L3.35965 2.31745L5.17612 0.500977H0.4375V5.2396ZM5.17612 14.7168L3.35965 12.9004L5.64209 10.6337L4.52061 9.51225L2.25397 11.7947L0.4375 9.97822V14.7168H5.17612ZM14.6534 9.97822L12.8369 11.7947L10.5703 9.51225L9.44878 10.6337L11.7312 12.9004L9.91474 14.7168H14.6534V9.97822Z",
    fill: "#404041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFullScreen);
export default __webpack_public_path__ + "static/media/ViewFullScreen.763262b371e5dbc93ce06c0e50e85ed2.svg";
export { ForwardRef as ReactComponent };